<router-outlet></router-outlet>
  <div class="h-[4rem]"></div>
    <div class="block ">
      <p-tabs class="fixed left-0 right-0 bottom-0 h-[4rem] z-20">
          <p-tablist content class="h-full">
            <p-tab value="lotteries" [routerLink]="['/lotteries']" [disabled]="disableLotteriesTab()"
                   class="flex-1 flex justify-center">
              <div class="flex items-center flex-col gap-1">
                <i class="pi pi-building"></i>
                <span class="text-xs">Lotteries</span>
              </div>
            </p-tab>
            <p-tab value="profile" [routerLink]="['/profile']" class="flex-1 flex justify-center">
              <div class="flex items-center flex-col gap-1">
                <i class="text-lg pi pi-users"></i>
                <span class="text-xs">Profile</span>
              </div>
            </p-tab>
            <p-tab value="applications" [routerLink]="['/applications']" class="applications-tab flex-1 flex justify-center">
              <div class="flex items-center flex-col gap-1">
                <i class="pi pi-file-check"></i>
                <span class="text-xs">Applications</span>
              </div>
            </p-tab>
            <p-tab value="support" [routerLink]="['/support']" class="flex-1 flex justify-center">
              <div class="flex items-center flex-col gap-1">
                <i class="pi pi-question"></i>
                <span class="text-xs">Support</span>
              </div>
            </p-tab>
          </p-tablist>
      </p-tabs>
    </div>
